import isString from 'lodash/isString'
import toString from 'lodash/toString'

function initials(value, glue='')
{
	const letters = toString(value)
		.replace(/[^a-zA-Z- ]/g, '')
		.match(/\b\w/g)

	if ( isString(glue) )
	{
		return letters?.join(glue)
	}

	return letters
}

export default initials